import React from 'react';

import { Grid, InputAdornment } from '@material-ui/core';
import styled from 'styled-components';
import { StyledTextField } from 'styles/admin';

import { SearchIcon } from 'constants/icons';

import { StyledSelect } from '../../Reviews/ReviewTemplate/common/styles';

const SearchTemplates = ({ search, onSearchChange, creators }) => (
  <SearchGrid container justify="flex-start" alignItems="center">
    <Grid item xs={7}>
      <StyledTextField
        margin="dense"
        fullWidth
        variant="outlined"
        id="input-with-icon-textfield-review-template"
        placeholder="Search templates"
        style={{ width: '85%' }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon size="tinier" />
            </InputAdornment>
          ),
        }}
        value={search.text}
        onChange={(e) => onSearchChange('text', e.target.value)}
      />
    </Grid>
    <SelectGridContainer item xs={5}>
      <StyledSelect
        value={creators.filter((item) => item.value === search.creator)[0]}
        onChange={(option) => onSearchChange('creator', option.value)}
        options={creators}
        classNamePrefix="react-select"
        placeholder="Created by"
      />
    </SelectGridContainer>
  </SearchGrid>
);

const SearchGrid = styled(Grid)`
  padding: 1rem 1.5rem 0.5rem 1.5rem;
`;

const SelectGridContainer = styled(Grid)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export default SearchTemplates;
